import React, { useEffect, useState } from "react";
import Link from "next/link";

import { useAppState } from "lib/appState";
import { forgotPasswordApi } from "api/auth.api";
import { useRouter } from "next/router";
import Button from "../../components/Button/Button";
import { Alert, CssBaseline, Typography } from "@mui/material";

import styles from "../../styles/register.module.scss";
import { Box } from "@mui/system";
import ReworkedLayout from "layouts/MarvyLayout";
import MarvyTextField from "components/atoms/MarvyTextField";

function Field({ ...props }) {
  return <MarvyTextField sx={{ mb: "30px" }} {...props} />;
}
export default function ForgotPassword() {
  const router = useRouter();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [data, setData] = useState({
    email: "",
  });
  const [appState, setAppState] = useAppState();
  const [disableBtn, setDisableBtn] = useState(true);

  useEffect(() => {
    if (appState.tokens) {
      router.push("/dashboard");
    }
  }, [appState]);

  async function forgotPassword({ email }) {
    try {
      let res = await forgotPasswordApi({ email });
      setSuccess(true);
    } catch (e) {
      const response = e.response;
      if (!response) setError("An unknown error has occurred");
      else {
        setError(response.data);
      }
      setDisableBtn(false);
    }
  }

  function submit(e) {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    forgotPassword(data);
    setDisableBtn(true);
  }
  return (
    <ReworkedLayout noMenu unauthenticated>
      <Typography
        // variant="h1"
        sx={{
          fontWeight: "700",
          fontSize: "24px",
          color: "white.main",
          mb: "30px",
        }}
        align="center"
      >
        Get a password reset link
      </Typography>
      <CssBaseline />
      <form className={styles.form} onSubmit={submit}>
        {error ? <Alert severity="error">{error.message}</Alert> : null}
        {success ? (
          <Alert severity="info">
            If the email you inserted is registered you will receive a password
            reset link. If you can't find it, remember to also check your spam
            folder.
          </Alert>
        ) : null}
        <Box sx={{ height: 50 }}></Box>
        <Field
          label="Email"
          placeholder="john.doe@example.com"
          value={data.email}
          onChange={(e) => {
            setData({ ...data, email: e.target.value });
            e.target.value !== "" ? setDisableBtn(false) : setDisableBtn(true);
          }}
          required
          type="email"
        />
        <Button disabled={disableBtn} type="submit">
          Reset password
        </Button>
      </form>
      <Box sx={{ height: "30px" }}></Box>
      <Link href="/auth/login">
        <Button variant="text">Return to log in</Button>
      </Link>
      <Box sx={{ height: "12px" }}></Box>
      <Link href="/auth/register">
        <Button variant="text">Sign up for a new account</Button>
      </Link>
    </ReworkedLayout>
  );
}
